import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-circle-slash",
  templateUrl: "./med-icon-circle-slash.component.html",
})
export class MedIconCircleSlashComponent extends SvgMixinComponent {}
